import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';

import { appRoutes } from '@tekman/onmat/constants';
import { ProfileFacade } from '@tekman/onmat/store/profile';

export const demoGuard: CanActivateFn = () => {
  const profileFacade = inject(ProfileFacade);
  const router = inject(Router);

  return profileFacade.userInfo$.pipe(
    map(userInfo => {
      if (!userInfo.isDemo) {
        return true;
      }
      return router.createUrlTree([appRoutes.itineraries]);
    })
  );
};
